import React from "react";
import "./Styles/flashCard.css"
import { priceFr } from "../Services/Numbers";
import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';

export default function FlashCard({ product = {} }) {
  const productsURL = process.env.REACT_APP_API_BASE_URL + '/images/products/';

  const goToProduct = (slug) => {
    window.location.href = "/boutique/"+slug;
  }

  let prices = '';
  let badge = '';
  
  if (product.discount) {
    let oldPrice = product.price;
    let newPrice = oldPrice - Math.round(oldPrice * product.discount / 100)
    prices = (<>
        <p><strong>{priceFr(newPrice)} F</strong> <span>{priceFr(oldPrice)} F</span></p>
    </>)

    badge = <span>-{product.discount}%</span>
  }
  else {
    prices = (<>
      <p><strong>{priceFr(product.price)} F</strong></p>
    </>)
  }

  let stars = [];
  for (let i = 0; i < product.stars; i++) {
    stars.push(<StarIcon key={'full-star_' + product.slug + '_' + (i + 1)} sx={{ color: 'gold', fontSize: '20px' }} />);
  }

  if (product.stars < 5) {
    for (let i = 0; i < 5 - product.stars; i++) {
      stars.push(<StarOutlineIcon key={'empty-star_' + product.slug + '_' + (i + 1)} sx={{ color: 'gold', fontSize: '20px' }} />);
    }
  }

  return (
    <div onClick={()=>{goToProduct(product.slug)}} className="flash-card-container">
        <div className="flash-card-content">
            <div className="flash-card-stars">{stars}</div>
            <h5>{product.name}</h5>
            {prices}
            {badge}
        </div>
      <div className="flash-card-img">
        <img src={productsURL+product.thumb} alt={product.thumb}/>
      </div>
    </div>
  );
}